module.exports = __webpack_public_path__ + "static/media/Right Lateral Cartoon.a77706fc.png";